import Axios from "axios";
import {
    SET_SUB_CATEGORY_LIST,
    UNSET_SUB_CATEGORY_LIST
} from "@/store/mutation-types";

import { saveUpdateSubCategory, getSubCategoryList } from "@/store/api";
// initial state
const state = {
    getSubCategoryList: [],
};

const getters = {
    getSubCategoryList(state) {
        return state.getSubCategoryList;
    }
};


const mutations = {
    [SET_SUB_CATEGORY_LIST](state, data) {
        state.getSubCategoryList = data;
    }   
,
    [UNSET_SUB_CATEGORY_LIST](state) {
        state.getSubCategoryList = [];
    }
};


const actions = {
    saveUpdateSubCategory({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateSubCategory, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSubCategoryList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getSubCategoryList, data)
                .then(function (response) {
                    commit('SET_SUB_CATEGORY_LIST', response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_SUB_CATEGORY_LIST');
                    reject(error);
                });
        });
    }
};


export default {
    state,
    getters,
    actions,
    mutations       
};